import {
    CloudOfferingKey,
    CloudProductKey,
    CurrencyISOCode,
    FormattedPriceCalculationResponse as BaseFormattedPriceCalculationResponse,
    OfferingHamsMap,
    OfferingSKUMap,
    PricingPeriod,
    PricingPlans
} from "@/components/wpl/pricing/src/price-finder/constants.tsx";
import { extractPricingTiersFromEntry } from "@/components/wpl/pricing/src/price-finder/utils/extract-pricing-tiers-from-entry.ts";
import { calculatePrice } from "@/components/wpl/pricing/src/price-finder/utils/price-calculation.ts";
import { getFreePriceCalc } from "@/components/wpl/pricing/src/price-finder/utils/use-price-finder-data.ts";
import { CCPOfferingContent } from "@/contentful/index.tsx";

export interface CalculatePlanPricingArgs {
    ccpPricingData: OfferingSKUMap<CloudOfferingKey, CCPOfferingContent>;
    ccpOfferingSKU: string | undefined;
    numUnits: number;
    period: PricingPeriod;
    currencyISOCode: CurrencyISOCode;
    localeISOCode: string;
}

export type FormattedPriceCalculationResponse =
    BaseFormattedPriceCalculationResponse & {
        offeringSku: string;
    };

const hamsPricingDataStub = {} as OfferingHamsMap<
    CloudProductKey,
    PricingPlans
>;
const hamsProductKeyStub = "" as CloudProductKey;

export function calculatePlanPricing(
    args: CalculatePlanPricingArgs
): FormattedPriceCalculationResponse {
    const {
        ccpPricingData,
        ccpOfferingSKU,
        period,
        numUnits,
        currencyISOCode,
        localeISOCode
    } = args;

    if (numUnits === 0) {
        return {
            offeringSku: ccpOfferingSKU as string,
            ...getFreePriceCalc(currencyISOCode)
        };
    } else {
        const pricingTiers = extractPricingTiersFromEntry(
            ccpPricingData,
            hamsPricingDataStub,
            period,
            currencyISOCode,
            ccpOfferingSKU,
            hamsProductKeyStub
        );

        if (!pricingTiers) {
            console.log(`Pricing tiers not found for ${period}.`);
            return {
                offeringSku: ccpOfferingSKU as string,
                ...getFreePriceCalc(currencyISOCode)
            };
        } else {
            return {
                offeringSku: ccpOfferingSKU as string,
                ...calculatePrice(
                    numUnits,
                    pricingTiers,
                    currencyISOCode,
                    period,
                    localeISOCode
                )
            };
        }
    }
}
